import React from 'react';
import { Wrapper, Inner, Eyebrow, Figures, Figure } from './proofstrip.style';

// Figures from Paweł Zubkiewicz's AWS cost audits and projects. The total
// across clients is worded as identified; $1.3M was saved (his own project,
// the same case as on the card further down); the EC2 figure carries no
// status word. Never "average". No client is named. Static on purpose: no
// carousel, no counting animation.
const FIGURES = [
  { value: '$8.7M+', label: 'savings identified for clients' },
  {
    value: '$1.3M a year',
    label: 'saved in one audit: 19,136 unused EBS volumes',
  },
  {
    value: '$153K a month',
    label: 'EC2 savings in one audit (2024)',
  },
];

// The band of audit figures under the first screen of the hero, still on the
// hero background. It is a band of its own (#audit_results) with its own
// heading and a rule above it, apart from the customer logos under it (which
// have a rule and a heading of their own), so no logo reads as the source of
// a figure.
const ProofStrip = () => (
  <Wrapper id="audit_results" aria-labelledby="audit-results-heading">
    <Inner>
      <Eyebrow id="audit-results-heading">From our AWS cost audits</Eyebrow>
      <Figures>
        {FIGURES.map((item) => (
          <Figure key={item.value}>
            <strong>{item.value}</strong>
            <span>{item.label}</span>
          </Figure>
        ))}
      </Figures>
    </Inner>
  </Wrapper>
);

export default ProofStrip;
